import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './index.css';
import { ProtectedRoute } from './atoms/protectedRoute'
import { Auth } from './pages/auth'
import { Logout } from './templates/logout'
import { Dashboard } from './pages/dashboard'
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path="/login" exact component={Auth} />
        <ProtectedRoute path="/logout" exact component={Logout} />
        <ProtectedRoute path="/" exact component={Dashboard} />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
